import { render, staticRenderFns } from "./AuthSet.vue?vue&type=template&id=53f5a18d&scoped=true&"
import script from "./AuthSet.vue?vue&type=script&lang=js&"
export * from "./AuthSet.vue?vue&type=script&lang=js&"
import style0 from "./AuthSet.vue?vue&type=style&index=0&id=53f5a18d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5a18d",
  null
  
)

export default component.exports